export interface DropdownItemProps {
  icon: JSX.Element;
  text: string | JSX.Element;
  onClickFunction: (event?: any) => void;
  className?: string;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  icon,
  text,
  onClickFunction,
  className = "w-full p-3 bg-white rounded-lg justify-start items-center gap-2 inline-flex text-neutral-700 hover:bg-neutral-50 cursor-pointer",
}) => {
  return (
    <button className={className} onClick={onClickFunction}>
      <div className="w-6 h-6 flex-shrink-0 relative fill-neutral-700">
        {icon}
      </div>
      <div className="text-base font-normal font-sans leading-7 text-ellipsis text-nowrap break-keep whitespace-nowrap overflow-hidden">
        {text}
      </div>
    </button>
  );
};

export default DropdownItem;
